import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';
import apiUrl from '../../../helpers/apiUrl';

export const createAgroLider = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/agro-lider`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      message.success('Pozytywnie utworzono');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const getAgroLiderRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/agro-lider`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

export const deleteAgroLiderById = async (
  agroLiderId: number
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/agro-lider/${agroLiderId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

export const getSpecificPAgroLiderRequest = async (
  id: string
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/agro-lider/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const saveAgroLiderRequest = async (data: {
  id: number;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/agro-lider/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};
